import { Injectable } from '@angular/core';
import { Global } from './global.service';
import { HttpHandler } from './httpHandler.service';
import { CacheService } from './cache.service';

@Injectable()
export class ApiService {
  constructor(
    private httpHandler: HttpHandler,
    private global: Global,
    private cacheService: CacheService
  ) { }
  getUnbindGateway(data = { page: 0, size: 10 }): Promise<any> {
    return this.httpHandler.post(
      Global.getApiHost().api +
      'deviceInfo/searchUnbind?page=' +
      data.page +
      '&size=' +
      data.size,
      data
    );
  }

  // 类目
  getCategoriesById(id: number) {
    return this.httpHandler.get(
      Global.getApiHost().api + 'categorie/getById?id=' + id
    );
  }

  getCategoriesList(data = { page: 0, size: 10 }): Promise<any> {
    return this.httpHandler.post(
      Global.getApiHost().api + 'categorie/list',
      data
    );
  }

  delCategories(id: number): Promise<any> {
    return this.httpHandler.get(
      Global.getApiHost().api + 'categorie/delete?id=' + id
    );
  }

  addCategories(data: object): Promise<any> {
    return this.httpHandler.post(
      Global.getApiHost().api + 'categorie/add',
      this.filterData(data)
    );
  }

  updateCategories(data: object): Promise<any> {
    return this.httpHandler.post(
      Global.getApiHost().api + 'categorie/update',
      this.filterData(data)
    );
  }

  updateCategoriesSort(data: object): Promise<any> {
    return this.httpHandler.post(
      Global.getApiHost().api + 'categorie/update/sort',
      data
    );
  }

  getBannerById(id: number) {
    // 暂时禁用缓存以排查内存问题
    return this.httpHandler.get(
      Global.getApiHost().api + 'banner/getById?id=' + id
    );
  }

  getBannerList(data = { page: 0, size: 10 }): Promise<any> {
    // 暂时禁用缓存以排查内存问题
    return this.httpHandler.post(Global.getApiHost().api + 'banner/list', data);
  }

  delBanner(id: number): Promise<any> {
    return this.httpHandler.get(
      Global.getApiHost().api + 'banner/delete?id=' + id
    );
  }

  addBanner(data: object): Promise<any> {
    return this.httpHandler.post(
      Global.getApiHost().api + 'banner/add',
      this.filterData(data)
    );
  }

  updateBanner(data: object): Promise<any> {
    return this.httpHandler.post(
      Global.getApiHost().api + 'banner/update',
      this.filterData(data)
    );
  }

  updateBannerSort(data: object): Promise<any> {
    return this.httpHandler.post(
      Global.getApiHost().api + 'banner/update/sort',
      data
    );
  }

  updateBannerReadings(data: object): Promise<any> {
    return this.httpHandler.post(
      Global.getApiHost().api + 'banner/update/readings',
      data
    );
  }

  // ========== 通用内容接口（可选，用于 News、Product 等）==========
  
  // 通用：获取内容列表
  getContentList(type: string, data = { size: 10, currentPage: 1 }): Promise<any> {
    return this.httpHandler.post(
      Global.getApiHost().api + 'content/list',
      { type, ...data }
    );
  }

  // 通用：获取内容详情
  getContentById(id: number, type?: string): Promise<any> {
    const url = type 
      ? `content/getById?id=${id}&type=${type}`
      : `content/getById?id=${id}`;
    return this.httpHandler.get(Global.getApiHost().api + url);
  }

  // News 相关
  getNewsList(data = { size: 10, currentPage: 1 }): Promise<any> {
    return this.httpHandler.post(Global.getApiHost().api + 'news/list', data);
  }

  getNewsById(id: number): Promise<any> {
    return this.httpHandler.get(Global.getApiHost().api + 'news/getById?id=' + id);
  }

  addNews(data: object): Promise<any> {
    return this.httpHandler.post(
      Global.getApiHost().api + 'news/add',
      this.filterData(data)
    );
  }

  updateNews(data: object): Promise<any> {
    return this.httpHandler.post(
      Global.getApiHost().api + 'news/update',
      this.filterData(data)
    );
  }

  delNews(id: number): Promise<any> {
    return this.httpHandler.get(Global.getApiHost().api + 'news/delete?id=' + id);
  }

  // Product 相关
  getProductList(data = {page:1 ,size: 10, currentPage: 1 }): Promise<any> {
    return this.httpHandler.post(Global.getApiHost().api + 'product/list', data);
  }

  getProductById(id: number): Promise<any> {
    return this.httpHandler.get(Global.getApiHost().api + 'product/getById?id=' + id);
  }

  addProduct(data: object): Promise<any> {
    return this.httpHandler.post(
      Global.getApiHost().api + 'product/add',
      this.filterData(data)
    );
  }

  updateProduct(data: object): Promise<any> {
    return this.httpHandler.post(
      Global.getApiHost().api + 'product/update',
      this.filterData(data)
    );
  }

  delProduct(id: number): Promise<any> {
    return this.httpHandler.get(Global.getApiHost().api + 'product/delete?id=' + id);
  }

  login(loginInfo: any): Promise<any> {
    return this.httpHandler.post(
      Global.getApiHost().api + 'user/login',
      loginInfo
    );
  }

  uploadImg(data: any): Promise<any> {
    return this.httpHandler.post(Global.getApiHost().api + 'img/upload', data);
  }

  getImg(name: string): Promise<any> {
    return this.httpHandler.get(
      Global.getApiHost().api + 'img/info?name=' + name
    );
  }

  filterData(obj: any) {
    for (let key in obj) {
      if (
        ((!obj[key] && obj[key] !== 0) || obj[key] == -1 || obj[key] == '-1') &&
        obj[key] !== false &&
        obj[key] !== 'false'
      ) {
        delete obj[key];
      }
    }
    return obj;
  }
}
